import React, { Children } from 'react';
import { motion } from 'framer-motion';
const problems = ['Domingo a la noche improvisando clases sin progresión pedagógica real', 'Temas difíciles (disociación, pivot, musicalidad) sin saber cómo secuenciarlos', 'Alumnos de distintos niveles y cero material diferenciado', 'El 70% abandona antes del año y no sabés cómo prevenirlo', 'No podés justificar un aumento porque no tenés un sistema profesional visible'];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function ProblemSection() {
  return <section className="w-full bg-black py-14 sm:py-20 px-4" data-id="element-213">
      <div className="max-w-2xl mx-auto" data-id="element-214">
        {/* Heading */}
        <motion.div className="text-center mb-10 sm:mb-12" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-215">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-snug" data-id="element-216">
            Si sos profe de tango en Argentina,
            <br data-id="element-217" />
            <span className="text-[#C8962E]" data-id="element-218">esto te va a sonar familiar:</span>
          </h2>
        </motion.div>

        {/* Problem list */}
        <motion.div className="space-y-2.5 sm:space-y-3 mb-12 sm:mb-14" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-219">
          {problems.map((text, i) => <motion.div key={i} variants={itemVariants} className="group flex items-start gap-3 sm:gap-4 bg-white/[0.015] border border-white/[0.05] rounded-xl px-4 sm:px-5 py-3.5 sm:py-4 overflow-hidden transition-all duration-300 hover:bg-red-950/30 hover:border-red-900/30 hover:shadow-[0_0_20px_rgba(220,38,38,0.06)]" style={{
          borderLeftWidth: 3,
          borderLeftColor: 'rgba(220,38,38,0.5)'
        }} data-id="element-220">
              <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-red-500/15 flex items-center justify-center mt-0.5 group-hover:bg-red-500/25 transition-colors duration-300" data-id="element-221">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="text-red-500" data-id="element-222">
                  <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-223" />
                </svg>
              </span>
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed group-hover:text-gray-200 transition-colors duration-300" data-id="element-224">
                {text}
              </p>
            </motion.div>)}
        </motion.div>

        {/* Closing hook */}
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-225">
          <p className="text-[#C8962E] text-xl sm:text-2xl md:text-3xl font-black mb-10 sm:mb-12 leading-snug" data-id="element-226">
            ¿Cuántos domingos más vas a perder
            <br className="hidden sm:inline" data-id="element-227" /> haciendo lo mismo?
          </p>

          <div className="h-px bg-gradient-to-r from-transparent via-[#C8962E]/60 to-transparent w-full" data-id="element-228" />
        </motion.div>
      </div>
    </section>;
}